export const AppPath = {
  BasePath: '/',
} as const
